import { render, staticRenderFns } from "./legal_lawyer_index.vue?vue&type=template&id=95e7ce0a&scoped=true"
import script from "./legal_lawyer_index.vue?vue&type=script&lang=js"
export * from "./legal_lawyer_index.vue?vue&type=script&lang=js"
import style0 from "./legal_lawyer_index.vue?vue&type=style&index=0&id=95e7ce0a&prod&scoped=true&lang=less"
import style1 from "./legal_lawyer_index.vue?vue&type=style&index=1&id=95e7ce0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e7ce0a",
  null
  
)

export default component.exports